<template></template>

<script>
export default {
  mounted() {
    this.$router.push({
      name: 'results',
      replace: true
    })
  }
}
</script>

<style>
</style>
